module.exports = __webpack_public_path__ + "10e1dd76a618d349daea584573d128de.pdf";